import { BrowserRouter } from "react-router-dom";
import { LocaleProvider } from "../i18n/LocaleProvider";
import { QueryProvider } from "./providers/QueryProvider";
import { AuthProvider } from "./providers/AuthProvider";
import { ToastProvider } from "../shared-ui/primitives";
import { AppRoutes } from "./routes";
import { BootGate } from "./BootGate";

export function App() {
  return (
    <LocaleProvider>
      <QueryProvider>
        <ToastProvider>
          <BrowserRouter>
            <AuthProvider>
              <BootGate>
                <AppRoutes />
              </BootGate>
            </AuthProvider>
          </BrowserRouter>
        </ToastProvider>
      </QueryProvider>
    </LocaleProvider>
  );
}
